import { useNotices } from '../../application/hooks/useNotices';
import { useTranslation } from '../../application/hooks/useTranslation';
import { formatDateTime } from '../../domain/formatters/date';
import { QueryState } from '../components/feedback/QueryState';
import { Badge } from '../components/ui/Badge';
import { Card } from '../components/ui/Card';
import './pages.css';

const CAT_TONE = { CORPORATE: 'info', EMI_REMINDER: 'warning', GENERAL: 'neutral' } as const;
const CAT_KEY = { CORPORATE: 'notices.corporate', EMI_REMINDER: 'notices.emi', GENERAL: 'notices.general' } as const;

/** W12 — role-filtered notices (E16) with explicit empty state. */
export default function NoticesPage() {
  const { t, locale } = useTranslation();
  const notices = useNotices();

  return (
    <div data-testid="notices-page">
      <div className="page-head">
        <h1 className="page-title">{t('notices.title')}</h1>
      </div>

      <QueryState
        loading={notices.isPending}
        error={notices.error}
        empty={!notices.isPending && (notices.data?.length ?? 0) === 0}
        onRetry={() => void notices.refetch()}
        skeletonCount={3}
      />
      <div className="stack">
        {(notices.data ?? []).map((n) => (
          <Card key={n.id} data-testid="notice-card">
            <div className="row-between">
              <strong>{n.title}</strong>
              <Badge tone={CAT_TONE[n.category]}>{t(CAT_KEY[n.category])}</Badge>
            </div>
            <p style={{ marginTop: 8 }}>{n.body}</p>
            <span className="muted">{formatDateTime(n.publishedAt, locale)}</span>
          </Card>
        ))}
      </div>
    </div>
  );
}
